import { render } from "./BrandNav.vue?vue&type=template&id=8679c676&scoped=true"
import script from "./BrandNav.vue?vue&type=script&lang=js"
export * from "./BrandNav.vue?vue&type=script&lang=js"

import "./BrandNav.vue?vue&type=style&index=0&id=8679c676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8679c676"]])

export default __exports__